module.exports = __webpack_public_path__ + "assets/c8d60d1436ff1c2d373b928ad09dc9c6.mp4";